import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// coraWebComponents
import withRouter from "../../coraWebComponents/utils/withRouter";
import Button from "../../coraWebComponents/buttons/Button";
import Tooltip from "../../coraWebComponents/forms/Tooltip";
import Checkbox from "../../coraWebComponents/forms/Checkbox";

import InfoData from "../User/InfoData";

// actions
import * as ziadostActions from "../../actions/ziadostActions";

// proptypes
import userPropTypes from "../../propTypes/userPropTypes";
import ziadostPropTypes from "../../propTypes/ziadostPropTypes";
import * as userUtils from "../../utils/userUtils";

import _ from "lodash";

class InfoZiadatel extends React.Component {
  constructor(props) {
    super(props);

    const user = props.user.Uzivatel;
    const infoZiadatel = props.ziadost.InfoZiadatel;
    this.state = {
      Ziadatel: infoZiadatel ? userUtils.formatUzivatel(infoZiadatel.Ziadatel) : userUtils.formatUzivatel(user),
      Vlastnik: infoZiadatel ? userUtils.formatUzivatel(infoZiadatel.Vlastnik) : {
        meno: "",
        priezvisko: "",
        nazov: "",
        ico: "",
        ulica: "",
        cs: null,
        co: "",
        psc: undefined,
        obec: "",
        email: "",
        telefon: "",
        radioValue: { label: "Fyzická osoba", value: "fyzOsoba" },
      },

      L_VLASTNIK: infoZiadatel ? infoZiadatel.L_VLASTNIK : false
    };
  }

  saveData = async () => {
    // IF VLASTNIK HAS DIFFERENT DATA AS ZIADATEL
    const { L_VLASTNIK } = this.state;

    const Ziadatel = _.cloneDeep(this.state.Ziadatel);
    const Vlastnik = L_VLASTNIK
      ? _.cloneDeep(this.state.Vlastnik)
      : _.cloneDeep(this.state.Ziadatel);

    const data = {
      Ziadatel,
      Vlastnik,
      L_VLASTNIK: L_VLASTNIK,
    };

    this.props.ulozData({ InfoZiadatel: data });
  };
  handleOnChange = (name, value) => {
    this.setState({ [name]: value });
  };
  handleOnChangeZiadatel = (name, value) => {
    this.setState((state) => ({
      Ziadatel: { ...state.Ziadatel, [name]: value },
    }));
  };
  handleOnChangeVlastnik = (name, value) => {
    this.setState((state) => ({
      Vlastnik: { ...state.Vlastnik, [name]: value },
    }));
  };

  componentDidMount = () => {
    if (this.props.setRef) this.props.setRef(this);
  };

  render() {
    const { cancel, onKeyDown, moveBack, moveNext, className, index } = this.props;
    const { Ziadatel, Vlastnik, L_VLASTNIK } = this.state;
    const media = window.matchMedia('only screen and (min-width: 768px)');

    return (
      <div className={`row m-0 ${className}`}>
        <div className={media.matches ? "col-6 offset-3 p-0 forWeb" : "col p-0 forMobile"}>
          <div className="card formular">
            <div className="form-body">
              {/* FORM */}
              <Tooltip>
                <form
                  id={media.matches ? `webForm${index}` : `webMobile${index}`}
                  className="k-form"
                  onSubmit={moveNext}
                  onKeyDown={onKeyDown}
                >
                  {/* TITLE */}
                  <div className="card-title">
                    <div>Informácie o žiadateľovi</div>
                  </div>
                  <p>&nbsp;</p>

                  <InfoData
                    infoData={Ziadatel}
                    mobile={media.matches ? false : true}
                    onChange={this.handleOnChangeZiadatel}
                  />

                  {/* CHECK BOX */}
                  <Checkbox
                    name="L_VLASTNIK"
                    value={L_VLASTNIK}
                    label={"Údaje o vlastníkovi sú odlišné od žiadateľa"}
                    onChange={this.handleOnChange}
                  />

                  <p>&nbsp;</p>
                  {L_VLASTNIK && (
                    <InfoData
                      infoData={Vlastnik}
                      mobile={media.matches ? false : true}
                      onChange={this.handleOnChangeVlastnik}
                    />
                  )}
                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button primary label="Zrusiť" onClick={cancel} />
                    <div className="flexGroup">
                      <Button primary label="Späť" onClick={moveBack} />
                      <Button type="submit" label="Ďalej" primary={true} />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.data
});

const mapDispatchToProps = (dispatch) => ({
  ulozData: (data) => dispatch(ziadostActions.ulozData(data)),
});

InfoZiadatel.propTypes = {
  setRef: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  moveNext: PropTypes.func.isRequired,
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  user: userPropTypes.user,
  ziadost: ziadostPropTypes.ziadost,
  className: PropTypes.string,
  getStepperState: PropTypes.func,
  ulozData: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InfoZiadatel)
);
